import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const LegalPolicyEditor = Loadable(lazy(() => import('../legalPolicies/LegalPolicyEditor')));
const LegalPolicyPreview = Loadable(lazy(() => import('../legalPolicies/LegalPolicyPreview')));

const PrivacyPolicyRoutes = [
  { path: '/dashboard/privacy-policy', element: <LegalPolicyEditor policyType="privacy" />, auth: authRoles.admin },
  { path: '/dashboard/privacy-policy/preview', element: <LegalPolicyPreview policyType="privacy" />, auth: authRoles.admin },
];

export default PrivacyPolicyRoutes;
